import { CatalogFilterState } from "../reducers/catalogFilterSlice";

export const getCreatedAtFilter = (d: Date): string => {
  const s = d.toISOString();
  return s.slice(0, s.lastIndexOf(".")) + "+00:00";
};

export const parseSpeciesToList = (
  species: CatalogFilterState["species"],
): string[] => {
  const result: string[] = [];
  Object.entries(species).forEach(([genus, data]) => {
    Object.entries(data.species).forEach(([speciesName, isSelected]) => {
      if (isSelected) {
        result.push(`${genus} ${speciesName}`);
      }
    });
  });
  return result;
};

export const formatDate = (dateString: string | Date | undefined): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
};

export const toggleSpeciesFilter = (
  currentSpecies: CatalogFilterState["species"],
  genus: string,
  speciesName?: string,
): CatalogFilterState["species"] => {
  const newSpecies = { ...currentSpecies };
  if (!newSpecies[genus]) {
    newSpecies[genus] = { selected: false, species: {} };
  }

  if (speciesName) {
    newSpecies[genus] = {
      ...newSpecies[genus],
      species: {
        ...newSpecies[genus].species,
        [speciesName]: !newSpecies[genus].species[speciesName],
      },
    };
    const anySpeciesSelected = Object.values(newSpecies[genus].species).some(
      (val) => val,
    );
    newSpecies[genus].selected = anySpeciesSelected;
  } else {
    const newSelected = !newSpecies[genus].selected;
    newSpecies[genus] = {
      ...newSpecies[genus],
      selected: newSelected,
      species: Object.keys(newSpecies[genus].species).reduce(
        (acc, key) => {
          acc[key] = newSelected;
          return acc;
        },
        {} as { [key: string]: boolean },
      ),
    };
  }
  return newSpecies;
};

export const generateUniqueCatalogId = (source: string, id: string): string => {
  if (source === "capture") {
    return `CAPTURE_${id}`;
  }
  return `SPECIMEN_${id}`;
};

export const fetchImageAsBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch image from ${url}`);
  }
  return await response.blob();
};
